import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const FoundingUsers = () => {
  const navigate = useNavigate();

  return (
    <section id="founding" className="relative">
      <div className="max-w-4xl mx-auto px-4 py-16 md:py-24">
        <div className="glass-panel rounded-[32px] p-8 md:p-12 text-center shadow-glass-elevated">
          <h2 className="heading-section text-white mb-4">Yes, it's new. That's the point.</h2>
          <p className="text-white/80 text-lg leading-relaxed max-w-2xl mx-auto mb-8">
            Crystal HACCP was built this year, in a working kitchen, on a phone — not
            bolted onto software from 2009. Temps logged in under a minute, deviations
            that write their own corrective action, and an export an inspector actually
            accepts. No binders, no retyping, no training day.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              onClick={() => navigate("/auth")}
              className="cta-primary px-8 py-4 font-semibold"
            >
              Start using it <ArrowRight size={18} className="ml-2" />
            </Button>
            <a
              href="mailto:info@crystalhaccp.com?subject=Crystal%20HACCP%20question"
              className="inline-flex items-center justify-center px-8 py-4 rounded-full border border-white/25 text-white font-semibold hover:bg-white/10 transition"
            >
              Ask me anything first
            </a>
          </div>
          <p className="text-white/50 text-sm mt-6">
            Paid plans from $34.99 per unit / month. Cancel any time.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FoundingUsers;